import useAppTranslation from "@hooks/language/useAppTranslation";
import {} from "@mantine/core";
import { useBasketStore } from "@modules/order/stores/Basket.store";
import { IconTagFilled } from "@tabler/icons-react";
import type { GetInputPropsReturnType } from "node_modules/@mantine/form/lib/types";
import CodeInput from "./CodeInput";

interface IVoucherProps extends GetInputPropsReturnType {
  onValidate: () => void;
  isValid: boolean;
  isDirty: boolean;
}

const VoucherInput: React.FC<IVoucherProps> = ({ ...rest }) => {
  const { t } = useAppTranslation("pages.order.basket.codeInput");
  const { setVoucherInfo } = useBasketStore();

  return (
    <CodeInput
      resetValidity={() => setVoucherInfo({ isValid: false, isFilled: false })}
      buttonLabel={t("promo")}
      icon={<IconTagFilled />}
      {...rest}
    />
  );
};

export default VoucherInput;
